export default "__VITE_ASSET__CWYIcdNi__"